import { MOST_COMMON_RATES } from '../constants';
import { CalculatorFieldName, CommonCurrency, CurrencyDetails, ExchangeRateResult } from '../types';

export const capitalize = (text) => {
    if (typeof text !== 'string') {
        return '';
    }

    const reg = /^(\s+)?([a-zæøå])/;
    const result = text.match(reg);

    if (result && result[2]) {
        text = text.replace(result[2], result[2].toUpperCase());
    }

    return text;
};

export const toCurrencyOrUndefined = (
    currencyCodeString: string,
    availableCurrencies: CurrencyDetails[],
): CurrencyDetails | undefined => availableCurrencies.find(({ currencyCode }) => currencyCode === currencyCodeString);

export const isCurrencyFieldName = (value: string | undefined): value is CalculatorFieldName => {
    if (typeof value === 'undefined') {
        return false;
    }

    return Object.values<string>(CalculatorFieldName).includes(value);
};

export const toNumberOrUndefined = (value: string | number | undefined): number | undefined => {
    if (typeof value === 'string') {
        if (value === '') {
            return undefined;
        }

        return Number(value);
    }

    return value;
};

export const toCalculatorFieldNameOrUndefined = (value: string | undefined): CalculatorFieldName | undefined => {
    if (!isCurrencyFieldName(value)) {
        return undefined;
    }

    return CalculatorFieldName[value];
};

export const getCurrencyDetailsFromCurrencyCode = (
    currencyCode: CommonCurrency,
    availableCurrencies: CurrencyDetails[],
): CurrencyDetails | undefined => availableCurrencies.find((currency) => currency.currencyCode === currencyCode);

export const getCalculatedCurrencyAmount = (
    fromAmount: number | undefined,
    exchangeRate: ExchangeRateResult | undefined,
) => {
    if (typeof fromAmount === 'undefined' || typeof exchangeRate === 'undefined') {
        return undefined;
    }

    return fromAmount * exchangeRate.rate;
};

export const isMostCommonCurrency = ({ currencyCode }: CurrencyDetails) => MOST_COMMON_RATES.includes(currencyCode);
